import wixAnimations from 'wix-animations';
import { getDayOfMonth, getShortDateString, getDayOfWeek, getShortMonth, getTimeString } from 'public/dateAndTime'
import { sendBi } from 'public/biModule'
import { BI_EVENTS } from 'public/biConsts'
import { getUpcomingEvents, getPastEvents } from 'backend/Events_Events.jsw'
import { renderPastEvents } from 'public/eventsUtils'
import wixLocation from 'wix-location'
import find from 'lodash/find'
import without from 'lodash/without'
import minBy from 'lodash/minBy'

$w.onReady(function () {
    getUpcomingEvents().then(upcomingEvents => {
        if (!upcomingEvents) {
            $w('#featuredEventImage').collapse()
            $w('#noEventsIndication').expand()
            $w('#featuredEventDetails').collapse()
        } else {
            const featuredEvent = getFeaturedEvent(upcomingEvents)
            const upcomingEventsWithoutFeatured = without(upcomingEvents, featuredEvent)

            renderUpcomingEvents(upcomingEventsWithoutFeatured)
            renderFeaturedEvent(featuredEvent)
        }
    })

    getPastEvents().then(async results => {
        const { pastEvents, hasNext } = results
        renderPastEvents(pastEvents)

        if (hasNext) {
            $w('#loadMorePastEvents').expand()
            $w('#loadMorePastEvents').onClick(async () => {
                $w('#loadMorePastEvents').disable()
                const skip = $w('#pastEventsRepeater').data.length
                const { pastEvents: morePastEvents, hasNext } = await getPastEvents({ skip })

                const allLoadedPastEvents = [...$w('#pastEventsRepeater').data, ...morePastEvents]
                $w('#pastEventsRepeater').data = allLoadedPastEvents
                $w('#loadMorePastEvents').enable()

                if (!hasNext) {
                    $w('#loadMorePastEvents').collapse()
                }
            })
        }
    })

    $w('#eventsContactUs').onWixFormSubmitted(() => {
        const BI_INPUTS = {
            light_box_name: 'velo events contact us',
            light_box_origin: 'Events'

        }
        sendBi(BI_EVENTS.LIGHTBOX_SUBMITED, Object.assign({}, BI_INPUTS))
    })
});

const renderFeaturedEvent = (featuredEvent) => {
    if (featuredEvent) {
        $w('#featuredEvent').expand()
        const { title, shortDescription, dateAndTime, thumbnail, eventType: { title: eventType, image: eventTypeImage } } = featuredEvent

        $w('#featuredEventTitle').text = title
        $w('#featuredEventType').text = eventType
        $w('#featuredEventImage').src = thumbnail ? thumbnail : eventTypeImage
        $w('#featuredRegisterButton').onClick(async () => {
            // await sendBi(BI_EVENTS.CALL_TO_ACTION, { button_name: 'register' })

            const featuredEventPage = featuredEvent['link-events-events-title']
            wixLocation.to(featuredEventPage)
        })
        $w('#featuredEventDescription').text = shortDescription
        $w('#featuredEventDate').text = getShortDateString(dateAndTime)
        $w('#featuredEventTime').text = getTimeString(dateAndTime)
    } else {
        $w('#featuredEvent').collapse()
    }
}

const renderUpcomingEvents = (upcomingEvents) => {
    const isThereEventsToRender = upcomingEvents && upcomingEvents.length > 0

    if (isThereEventsToRender) {
        $w('#upcomingEvents').expand()
        $w('#eventsRepeater').onItemReady(async ($item, itemData) => {
            const { title, shortDescription, dateAndTime, eventType: { title: eventType } } = itemData
            setEventDateAndTime($item, dateAndTime)

            $item('#eventTitle').text = title
            $item('#eventDescription').text = shortDescription
            $item('#eventType').text = eventType

            seToggletEventDetailsBehaviour($item)

            $item('#eventLearnMore').onClick(async () => {
                const eventPage = itemData['link-events-events-title']
                wixLocation.to(eventPage)
            })
        })

        $w('#eventsRepeater').data = upcomingEvents
    } else {
        $w('#upcomingEvents').collapse()
    }
}

const getFeaturedEvent = (upcomingEvents) => {
    const featuredEvent = find(upcomingEvents, { featured: true })

    if (!featuredEvent) {
        const mostRecentEvent = minBy(upcomingEvents, 'dateAndTime')
        return mostRecentEvent
    }
    return featuredEvent
}

const setEventDateAndTime = ($item, dateAndTime) => {
    $item('#eventDayOfMonth').text = getDayOfMonth(dateAndTime)
    $item('#eventDayOfWeek').text = getDayOfWeek(dateAndTime)
    $item('#eventShortMonth').text = getShortMonth(dateAndTime)
    $item('#eventTime').text = getTimeString(dateAndTime)
}

const seToggletEventDetailsBehaviour = ($item) => {
    $item('#toggleEventDetails').onClick(() => {
        const shouldExpand = $item('#descriptionBox').collapsed

        const allArrowAnimations = []
        $w('#eventsRepeater').forEachItem(($item, itemData) => {
            $item('#descriptionBox').collapse()
            allArrowAnimations.push(addReverseArrowAnimation($item))
            allArrowAnimations.forEach(animation => animation.play())
        })

        if (shouldExpand) {
            $item('#descriptionBox').expand()
            const rotateArrow = addArrowAnimation($item)

            rotateArrow.play()
        }
    })
}

const addArrowAnimation = ($item) => {
    const rotateArrow = wixAnimations.timeline()

    rotateArrow.add($item('#arrow'), {
        rotate: 180,
        duration: 200,
        delay: 0
    })

    return rotateArrow
}

const addReverseArrowAnimation = ($item) => {
    const rotateArrow = wixAnimations.timeline()

    rotateArrow.add($item('#arrow'), {
        rotate: 0,
        duration: 200,
        delay: 0
    })

    return rotateArrow
}